<template>
  <q-dialog v-model="showEditCash">
    <q-card :style="{ 'width': '450px', 'max-width': '95%' }">
      <q-card-section
        class="text-h5"
      >
        Cash Amount
      </q-card-section>

      <q-card-section class="row justify-evenly items-center">
        <q-input
          ref="cashAmount"
          v-model.number="cashReceived"
          label="Cash Received"
          :prefix="currentCircuit.localeCurrencySymbol"
          type="number"
          step="0.01"
          :rules="[
            val => val > 0 || 'Must be positive value',
            val => val !== null && val !== '' || 'Cannot be blank'
          ]"
          autofocus
          @keyup.enter="setCash(cashReceived); showEditCash = false"
        />
      </q-card-section>

      <q-card-actions class="row justify-end q-ma-sm">
        <q-btn
          v-close-popup
          label="Done"
          color="primary"
          :text-color="buttonTextColor"
          @click="setCash(cashReceived)"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
export default {
  name: 'EditCashDialog',
  emits: ['set-cash'],
  data () {
    return {
      cashReceived: 0,
      showEditCash: false
    }
  },
  computed: {
    buttonTextColor () {
      return this.$isColorDark(this.currentSite.primaryColor) ? 'white' : 'black'
    }
  },
  methods: {
    async show (initialCashAmount = 0) {
      this.cashReceived = initialCashAmount
      this.showEditCash = true

      await this.$nextTick()
      this.$refs.cashAmount.select()
    },
    setCash (cash) {
      this.$emit('set-cash', cash)
    }
  },
  configuration: ['currentCircuit', 'currentSite']
}
</script>
